import { z } from "zod";
import { AppRoleSchema, ROLE_PRIORITY, AppRoleSet } from "./roles";
import type { AppRole } from "./roles";

const RoleArraySchema = z.array(AppRoleSchema);

export const normalizeRole = (raw: string | null | undefined): AppRole | null => {
  if (!raw) return null;
  const legacy: Record<string, AppRole> = {
    associado: "assessor",
    investor: "investidor",
  };
  if (raw in legacy) return legacy[raw];
  const result = AppRoleSchema.safeParse(raw);
  return result.success ? result.data : null;
};

export const resolvePrimaryRole = (roles: AppRole[]): AppRole | null => {
  const validated = RoleArraySchema.safeParse(roles);
  const list = validated.success ? validated.data : roles;
  for (const r of ROLE_PRIORITY) {
    if (list.includes(r)) return r;
  }
  return null;
};

export type RbacSubject = string;
export type RbacAction = "read" | "write" | "delete" | "manage";

export const canAccess = (
  role: AppRole,
  _subject: RbacSubject,
  _action: RbacAction
): boolean => {
  const parsed = AppRoleSchema.safeParse(role);
  if (!parsed.success) return false;
  if (parsed.data === "admin") return true;
  return AppRoleSet.has(parsed.data);
};

export const hasRole = (roles: AppRole[], required: AppRole): boolean =>
  new Set<AppRole>(roles).has(required);

export const hasAnyRole = (roles: AppRole[], allowed: AppRole[]): boolean => {
  const set = new Set<AppRole>(roles);
  return allowed.some((r) => set.has(r));
};
